import { BottomSignUpSection } from "pages/Main/BottomSignUpSection";
import { ClientExperienceSection } from "pages/Main/ClientExperienceSection";
import { ProblemSection } from "pages/Main/ProblemSection";
import { SolutionSection } from "pages/Main/SolutionSection";
import { TestimonialSection } from "pages/Main/TestimonialSection";
import React from "react";
import { HeroSection } from "./HeroSection";

export function Main() {
  return (
    <>
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <ClientExperienceSection />
      <TestimonialSection />
      <BottomSignUpSection />
    </>
  );
}
